export default {"src":"/_next/static/media/latest.4c7532a4.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};